import { Divider, Select } from "antd";
import React, { useEffect, useState } from "react";
import WebUtils from "../../../../../utils/WebUtils";
import { getAllJdsApi } from "../../../../../api/candidate";
import CreatePrepGuideMainPage from "../CreatePrepGuideMainPage";

const { Option } = Select;

function ChooseCreationTypeSec({
  setSteps,
  setLoading,
  userDetail,
  setJdId,
  steps,
  manualGuideFlag,
  setmanualGuideFlag,
  allJobs,
  setAllJobs,
}) {
  const getAllJds = async () => {
    const url = `${getAllJdsApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&organizationId=${userDetail.organizationId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setAllJobs(result.data.data);
        } else {
          setAllJobs(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (steps === 1) {
      getAllJds();
    }
  }, [steps]);
  return (
    <>
      {manualGuideFlag ? (
        <CreatePrepGuideMainPage
          setSteps={setSteps}
          setmanualGuideFlag={setmanualGuideFlag}
          setJdId={setJdId}
        />
      ) : (
        <div className="max-w-[500px] m-auto">
          <div className="">
            <p className="text-[#475467] text-[.95rem] font-medium">
              Select from your Jobs{" "}
            </p>
            <Select
              className="w-full mt-1"
              size="large"
              placeholder="Select a job role"
            >
              {allJobs?.map((job) => (
                <Option key={job?.jdIdentifier} value={job?.jdIdentifier}>
                  <div
                    onClick={() => {
                      setSteps(2);
                      setJdId(job?.jdIdentifier);
                    }}
                    className="flex flex-col"
                  >
                    <div className="flex justify-between items-center">
                      <span className="font-medium text-gray-800">
                        {job.jobTitle}
                      </span>
                      <span className="text-sm text-gray-500">
                        {job.jdIdentifier}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>{job.companyName}</span>
                      <span>{job.yearsOfExperience} yrs</span>
                    </div>
                  </div>
                </Option>
              ))}
            </Select>
          </div>
          <Divider style={{ borderColor: "#E4E7EC" }} className="my-2 ">
            Or
          </Divider>
          <div className="text-center">
            <button
              onClick={() => setmanualGuideFlag(true)}
              className="btn-orange px-4 py-1"
            >
              Create New Role
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ChooseCreationTypeSec;
